import React, { useEffect, useState } from 'react'

import CreatorList from '@/components/shared/creator-list'
import Page from '@/components/shared/page'
import MediaColumn from '@/components/shared/vault/media-column'
import { Media } from '@/model/media'
import { readAllCreators } from '@/redux/creator-actions'
import {
  useAppDispatch,
  useAppSelector,
} from '@/redux/utils'

import s from './vault.module.css'

export default function Vault() {
  const [selectedMedias, setSelectedMedias] = useState<Media[]>([])
  const creatorId = useAppSelector((state) => state.creator.selectedCreatorId)
  const dispatch = useAppDispatch()

  useEffect(() => {
    void dispatch(readAllCreators())
  }, [dispatch])

  return (
    <Page
      contentClassName={s.Content}
      sider={<CreatorList />}
    >
      {creatorId && (
        <>
          <MediaColumn
            creatorId={creatorId}
            selectedMedias={selectedMedias}
            onSelectMedias={setSelectedMedias}
          />
        </>
      )}
    </Page>
  )
}
